import { styled } from '@material-ui/core';

export const EditProfileSideInfoContentContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  justifyContent: 'center',
  gap: 20,
}));

export const EditProfileSideInfoLoading = styled('div')(({ theme }) => ({
  height: 100,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 20,
}));
